import { BillPayTransactionRequest, BillPayTransactionResponse } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
const { api } = vopayApi;
import { useDataFetchIndicator } from '..';

export default function useFetchBillPayTransaction({ bearer }: { bearer?: string } = {}) {
  const source = axios.CancelToken.source();
  const [details, setDetails] = useState<BillPayTransactionResponse>();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  const fetchBillPayTransaction = async (request: BillPayTransactionRequest) => {
    try {
      setDataFetchingInfo(true);
      const res = await api.fetchBillPayTransaction(request, bearer, source);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setDetails(res);
      return res;
    } catch (err) {
      console.error(err);

      throw err;
    } finally {
      setDataFetchingInfo(false);
    }
  };

  return {
    details,
    fetchBillPayTransaction,
  };
}
